import { render, staticRenderFns } from "./ProfissionalPage.vue?vue&type=template&id=b3ef7238"
import script from "./ProfissionalPage.vue?vue&type=script&lang=js"
export * from "./ProfissionalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports